// App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import HeaderBar from "./components/Layout/HeaderBar";
import NavBar from "./components/Layout/NavBar";
import PharmacyLocator from "./components/PharmacyLocator/PharmacyLocator";
import "./App.css";
import RegisterPharmacy from "./components/RegisterPharmacy/RegisterPharmacy";
import AdminLogin from "./components/AdminPanel/AdminLogin";
function App() {
  return (
    <>
      <HeaderBar />
      <NavBar />
      <Routes>
        <Route path="/" element={<PharmacyLocator />} />
        <Route path="/register-pharmacy" element={<RegisterPharmacy />} />
        <Route path="/adminlogin" element={<AdminLogin />} />
      </Routes>
    </>
  );
}

export default App;
